import React from "react";
import { Navigate } from "react-router-dom";
import { isEmpty } from "../lib/utils";
import { useSelector } from "react-redux";
import { RootState } from "../app/store";
import GlobalUploadProvider from "../features/globalUpload/GlobalUploadProvider";

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const user = useSelector((state: RootState) => state.user.value);

  if (isEmpty(user)) {
    return <Navigate to="/login" replace />;
  }

  // Every authenticated screen gets the page-wide drag-and-drop upload for
  // free by being wrapped here, with no per-page wiring.
  return (
    <GlobalUploadProvider>
      {children}
    </GlobalUploadProvider>
  );
};

export default AuthGuard;
